import {getAdvertPush, getAdvertClickList} from '@/http/api'

export default {
  namespaced: true,
  state: {
    noticeList: [],
    noticeClickList: []
  },
  mutations: {
    SET_NOTICELIST: (state, list) => {
      state.noticeList = [...list]
    },
    SET_NOTICECLICKLIST: (state, list) => {
      state.noticeClickList = list.map(item => item.clickAdvertId)
    }
  },
  actions: {
    // 获取广告
    getAdvertPush({commit}) {
      return new Promise(resolve => {
        getAdvertPush({
          providerType: 7,
          positionNo: 3
        }).then(res => {
          if (res.result === 'SUCCEED') {
            let list = res.data[0]?.adverts || []
            commit('SET_NOTICELIST', list)
            resolve()
          }
        })
      })
    },
    // 获取已点击列表
    getAdvertClickList({commit, rootState}) {
      return new Promise(resolve => {
        getAdvertClickList({
          providerType: 7,
          clientId: rootState.account.clientId
        }).then(res => {
          if (res.result === 'SUCCEED') {
            commit('SET_NOTICECLICKLIST', res.data)
            resolve()
          }
        })
      })
    }
  }
}
